import React, { useState, useRef } from "react";
import HCaptcha from "@hcaptcha/react-hcaptcha";
import MessageBox from "./Messagebox";
import LoadingBox from "./LoadingBox";
import { Link } from "react-router-dom";

const DropContact = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [phone, setPhone] = useState("");
  const [name, setName] = useState("");
  const [preferredTime, setPreferredTime] = useState("3");
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [captchaToken, setCaptchaToken] = useState(null);
  const captchaRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    let tempErrors = {};
    if (!name.trim()) tempErrors.name = "Required";
    if (!phone.trim()) tempErrors.phone = "Required";
    if (!captchaToken) tempErrors.captcha = "Please complete the captcha";
    setErrors(tempErrors);
    if (Object.keys(tempErrors).length === 0) {
      setIsSubmitting(true);
      setIsLoading(true);
      const callBackRequested = {
        dateTime: new Date().toISOString(),
        userName: name,
        userMobileNumber: phone,
        timeOfDay: parseInt(preferredTime),
        captchaToken,
      };
      try {
        const response = await fetch(
          "https://trademinwebapp-g5atgdgehba7dpbb.westus2-01.azurewebsites.net/api/Integration/requestContactUs",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(callBackRequested),
          },
        );
        const contentType = response.headers.get("content-type");
        const responseData = contentType?.includes("application/json")
          ? await response.json()
          : await response.text();
        setIsLoading(false);
        setMessage(responseData.errorMessage || "Request processed");
        setIsOpen(true);
        if (responseData.validationResponse) {
          setPhone("");
          setName("");
          setPreferredTime("3");
          setErrors({});
          setCaptchaToken(null);
          captchaRef.current?.resetCaptcha();
        } else {
          setCaptchaToken(null);
          captchaRef.current?.resetCaptcha();
        }
      } catch (error) {
        setIsLoading(false);
        setMessage("An error occurred while submitting request");
        setIsOpen(true);
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  const styles = `
    @import url('https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500&display=swap');

    .dc-wrap {
      font-family: 'DM Sans', sans-serif;
      background: #fff;
      border: 1px solid #e8e8e4;
      padding: 2.5rem;
    }

    .dc-field { margin-bottom: 1rem; }
    .dc-row { display: grid; grid-template-columns: 1fr 1fr; gap: 1rem; margin-bottom: 1rem; }

    .dc-label {
      display: flex; align-items: center; justify-content: space-between;
      font-size: 0.62rem; letter-spacing: 0.2em; text-transform: uppercase;
      color: #E78730; font-weight: 500; margin-bottom: 0.5rem;
    }
    .dc-error { font-size: 0.65rem; color: #c0392b; font-weight: 400; letter-spacing: 0; text-transform: none; }

    .dc-input, .dc-select {
      width: 100%; padding: 0.7rem 0.85rem;
      background: #fafaf8; border: 1px solid #e8e8e4; border-bottom: 1px solid #ccc;
      font-family: 'DM Sans', sans-serif; font-size: 0.875rem; font-weight: 300;
      color: #1a1a1a; outline: none; transition: border-color 0.2s, background 0.2s;
      box-sizing: border-box; appearance: none;
    }
    .dc-input::placeholder { color: #ccc; }
    .dc-input:focus, .dc-select:focus { border-color: #E78730; background: #fff; }
    .dc-select { cursor: pointer; background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%23E78730'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M19 9l-7 7-7-7'%3E%3C/path%3E%3C/svg%3E"); background-repeat: no-repeat; background-position: right 0.75rem center; background-size: 1rem; padding-right: 2.5rem; }

    .dc-info {
      display: flex; align-items: flex-start; gap: 0.75rem;
      border-left: 2px solid #E78730;
      padding: 0.75rem 1rem;
      background: #fdf8f3;
      margin-bottom: 1rem;
    }
    .dc-info-text { font-size: 0.8rem; color: #888; line-height: 1.6; font-weight: 300; }
    .dc-info-text strong { color: #E78730; font-weight: 500; }

    .dc-captcha-wrap { display: flex; flex-direction: column; align-items: center; gap: 0.4rem; margin-bottom: 1.25rem; }

    .dc-privacy { font-size: 0.7rem; color: #aaa; text-align: center; line-height: 1.7; margin-bottom: 1.25rem; font-weight: 300; }
    .dc-privacy a { color: #E78730; text-decoration: none; }
    .dc-privacy a:hover { text-decoration: underline; }

    .dc-submit {
      width: 100%; background: #E78730; color: #fff; border: none; cursor: pointer;
      padding: 0.875rem; font-size: 0.7rem; font-weight: 500;
      letter-spacing: 0.18em; text-transform: uppercase;
      font-family: 'DM Sans', sans-serif; transition: opacity 0.2s; margin-bottom: 1.5rem;
    }
    .dc-submit:hover:not(:disabled) { opacity: 0.8; }
    .dc-submit:disabled { background: #ddd; cursor: not-allowed; color: #aaa; }

    .dc-divider { border: none; border-top: 1px solid #e8e8e4; margin-bottom: 1.25rem; }

    .dc-direct { text-align: center; }
    .dc-direct-label { font-size: 0.65rem; letter-spacing: 0.14em; text-transform: uppercase; color: #bbb; font-weight: 400; margin-bottom: 0.75rem; }
    .dc-direct-links { display: flex; align-items: center; justify-content: center; gap: 1.5rem; flex-wrap: wrap; }
    .dc-direct-link { display: inline-flex; align-items: center; gap: 0.4rem; font-size: 0.8rem; color: #1a1a1a; text-decoration: none; font-weight: 400; transition: color 0.2s; }
    .dc-direct-link:hover { color: #E78730; }

    @media (max-width: 560px) {
      .dc-wrap {
        padding: 1.5rem 1rem;
        box-sizing: border-box;
        overflow-x: hidden;
        width: 100%;
      }

      .dc-row {
        grid-template-columns: 1fr;
        gap: 0.75rem;
      }

      .dc-input, .dc-select {
        width: 100%;
        max-width: 100%;
        box-sizing: border-box;
      }

      .dc-direct-links {
        flex-direction: column;
        gap: 0.5rem;
        width: 100%;
      }
    }
  `;

  return (
    <>
      <style>{styles}</style>
      <form className="dc-wrap" onSubmit={handleSubmit}>
        <div className="dc-row">
          <div>
            <div className="dc-label">
              Name *{" "}
              {errors.name && <span className="dc-error">{errors.name}</span>}
            </div>
            <input
              className="dc-input"
              type="text"
              maxLength={20}
              value={name}
              onChange={(e) => {
                if (e.target.value.length <= 20) setName(e.target.value);
              }}
              placeholder="Your name"
              disabled={isSubmitting}
            />
          </div>
          <div>
            <div className="dc-label">
              Phone *{" "}
              {errors.phone && <span className="dc-error">{errors.phone}</span>}
            </div>
            <input
              className="dc-input"
              type="tel"
              maxLength={15}
              value={phone}
              onChange={(e) => {
                if (e.target.value.length <= 15) setPhone(e.target.value);
              }}
              placeholder="123456789"
              disabled={isSubmitting}
            />
          </div>
        </div>

        <div className="dc-field">
          <div className="dc-label">Preferred Call Time</div>
          <select
            className="dc-select"
            value={preferredTime}
            onChange={(e) => setPreferredTime(e.target.value)}
            disabled={isSubmitting}
          >
            <option value="3">Any Time</option>
            <option value="0">Morning (8AM – 12PM)</option>
            <option value="1">Afternoon (12PM – 5PM)</option>
            <option value="2">Evening (5PM – 8PM)</option>
          </select>
        </div>

        <div className="dc-info">
          <svg
            width="14"
            height="14"
            viewBox="0 0 20 20"
            fill="#E78730"
            style={{ flexShrink: 0, marginTop: 2 }}
          >
            <path
              fillRule="evenodd"
              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
              clipRule="evenodd"
            />
          </svg>
          <p className="dc-info-text">
            <strong>Quick response:</strong> Our team typically responds within
            2–4 business hours.
          </p>
        </div>

        <div className="dc-captcha-wrap">
          {errors.captcha && (
            <span style={{ fontSize: "0.7rem", color: "#c0392b" }}>
              {errors.captcha}
            </span>
          )}
          <HCaptcha
            sitekey="c754f034-319e-488c-89b8-240c44f621e4"
            onVerify={(token) => setCaptchaToken(token)}
            onExpire={() => setCaptchaToken(null)}
            ref={captchaRef}
            theme="light"
          />
        </div>

        <p className="dc-privacy">
          By submitting, you agree to our{" "}
          <Link to="/privacy-policy">Privacy Policy</Link>. Your information is
          used only to respond to your request.
        </p>

        <button type="submit" className="dc-submit" disabled={isSubmitting}>
          {isSubmitting ? "Submitting..." : "Request Call Back"}
        </button>

        <div className="dc-divider" />

        <div className="dc-direct">
          <p className="dc-direct-label">Prefer to reach out directly?</p>
          <div className="dc-direct-links">
            <a href="tel:+6422106796" className="dc-direct-link">
              <svg
                width="13"
                height="13"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                />
              </svg>
              +64 22 106 2796
            </a>
            <span style={{ width: 1, height: 16, background: "#e8e8e4" }} />
            <a
              href="mailto:Franco.stander@trademin.co.nz"
              className="dc-direct-link"
            >
              <svg
                width="13"
                height="13"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                />
              </svg>
              Franco.stander@trademin.co.nz
            </a>
          </div>
        </div>
      </form>

      <LoadingBox isOpen={isLoading} />
      <MessageBox
        message={message}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </>
  );
};

export default DropContact;
